/**
 * D6 PnL values whose absolute value is below this threshold render as
 * neutral (no color, no sign pill). Shared by the active position surfaces so
 * their display tone agrees to the cent.
 */
export const PNL_DUST_D6: number = 5_000;

/**
 * Per-outcome holding entry. Number-or-string fields tolerate both raw SDK
 * output and pre-coerced numbers.
 */
export interface HoldingEntry {
  outcomeIndex: string | number;
  balance: string | number;
  avgEntryPrice: string | number;
  totalCost: string | number;
  realizedPnl: string | number;
  realizedCostBasis: string | number;
  tradeCount: string | number;
}

/** Tailwind class name for a PnL text value. Semantic tokens only. */
export function pnlColorClass(valueD6: number | bigint): string {
  const isDust =
    typeof valueD6 === 'bigint'
      ? (valueD6 < BigInt(0) ? -valueD6 : valueD6) < BigInt(PNL_DUST_D6)
      : Math.abs(valueD6) < PNL_DUST_D6;
  if (isDust) return 'text-foreground-disabled';
  if (valueD6 > 0) return 'text-data-profit';
  return 'text-data-loss';
}

/** Tailwind class names for a PnL pill (background + text). Semantic tokens only. */
export function pnlPillClass(valueD6: number): string {
  if (Math.abs(valueD6) < PNL_DUST_D6) return 'bg-background-tertiary text-foreground-secondary';
  if (valueD6 > 0) return 'bg-feedback-success-accent/10 text-data-profit';
  return 'bg-feedback-error-accent/10 text-data-loss';
}

/** Returns `+` for strictly-positive values, empty string otherwise. */
export function signedPrefix(value: number): '+' | '' {
  return value > 0 ? '+' : '';
}
